module.exports = __webpack_public_path__ + "img/logo.d080225a.png";